import {
  ApiGroupRoutes,
  GetGroupsRequest,
  Group,
  GroupResource,
  ProfileGroupStatus,
  ResourceIDRequest
} from '@foxbun/lib-goferal-types';
import * as t from 'ts-codec';
import { ResourceId } from '@journeyapps-labs/micro-codecs';
import { BaseApiClient } from '../base/BaseApiClient';

export class GroupsClient extends BaseApiClient {
  getGroup(req: ResourceIDRequest) {
    return this.post({
      path: ApiGroupRoutes.GET_GROUP,
      req: ResourceId,
      res: GroupResource,
      params: req,
      buffered: true
    });
  }

  getGroups(req: GetGroupsRequest) {
    return this.paginate({
      path: ApiGroupRoutes.GET_GROUPS,
      req: GetGroupsRequest,
      codec: GroupResource,
      params: req
    });
  }

  getMyGroupStatus(req: ResourceIDRequest) {
    return this.post({
      path: ApiGroupRoutes.GET_MY_GROUP_STATUS,
      req: ResourceId,
      res: ProfileGroupStatus.or(t.Null),
      params: req,
      buffered: true
    });
  }

  createGroup(req: Group) {
    return this.post({
      path: ApiGroupRoutes.CREATE_GROUP,
      req: Group,
      params: req
    });
  }

  joinGroup(req: ResourceIDRequest) {
    return this.post({
      path: ApiGroupRoutes.JOIN_GROUP,
      req: ResourceId,
      params: req
    });
  }

  leaveGroup(req: t.Decoded<typeof ResourceId>) {
    return this.post({
      path: ApiGroupRoutes.LEAVE_GROUP,
      req: ResourceId,
      params: req
    });
  }
}
